/*jshint esversion: 11 */
import React, { useState, useEffect, useMemo } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Table,
  Label,
  FormGroup,
  Button,
  Badge,
  Nav,
  NavItem,
  NavLink,
  ModalHeader,
  ModalBody,
  Modal,
  ModalFooter,
  Alert,
  Input
} from 'reactstrap';
import { connect } from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import PageDataLoader from '../Utility/PageDataLoader';
import Paginator from '../Utility/Paginator';
import { getTodoInfo, getTodoList } from '../../api/todo';
import moment from 'moment';
import CreateTodoModal from './CreateTodoModal';
import ViewTodoModal from './ViewTodoModal';
import UpdateTodoModal from './UpdateTodoModal';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { getStaffList } from '../../api/staff';
import { todoStatusOptions } from '../../helpers/todo';
import validator from 'validator';
import { stringify as QStringify, parse as QParse } from 'qs';
import { useHistory } from 'react-router-dom';
import { AvForm } from 'availity-reactstrap-validation';
import DeleteTodoModal from './DeleteTodoModal';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const animatedComponents = makeAnimated();

const TodoListPage = ({ authUser }) => {
  const history = useHistory();

  const [breadcrumbItems] = useState([
    { title: 'Todos', link: '#' },
    { title: 'View List', link: '#' }
  ]);
  const [activeTab, setActiveTab] = useState('assigned_by');
  const [todoListLoading, setTodoListLoading] = useState(true);
  const [todoList, setTodoList] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageLimit: 10,
    totalEntries: 0,
    totalPages: 0
  });
  const [filterError, setFilterError] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [currentFilterCount, setCurrentFilterCount] = useState(0);
  const [addTodoModalOpen, setAddTodoModalOpen] = useState(false);
  const [todoInfo, setTodoInfo] = useState({});
  const [todoInfoLoading, setTodoInfoLoading] = useState(false);
  const [todoInfoModalOpen, setTodoInfoModalOpen] = useState(false);
  const [updateTodoModalOpen, setUpdateTodoModalOpen] = useState(false);
  const [deleteTodoModalOpen, setDeleteTodoModalOpen] = useState(false);
  const [expectedDateFilter, setExpectedDateFilter] = useState({
    startDate: null,
    endDate: null
  });
  const [staffQueryId, setStaffQueryId] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [selectedStaffOption, setSelectedStaffOption] = useState([]);
  const [filterStatus, setFilterStatus] = useState(null);
  const [todoId, setTodoId] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);

  const staffOptions = useMemo(
    () => buildStaffOptions(staffList),
    // eslint-disable-next-line
    [staffList]
  );

  let listElem = document.getElementById('todoList');
  let linkElem = document.getElementById('todoLink');

  useEffect(() => {
    if (listElem) listElem.classList.add('mm-active');
    if (linkElem) linkElem.classList.add('active');
    if (authUser) {
      populateSearchOptions(history?.location?.search);
      fetchStaffList();
    }
    // eslint-disable-next-line
  }, [authUser, listElem, linkElem]);

  const handlePagination = (page) => {
    fetchData(page, pagination.pageLimit, activeTab, createQueryOptions());
  };

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 100
    })
  };

  const fetchData = async (
    current_page = 1,
    page_limit = 10,
    filter = activeTab,
    queryOptions = {}
  ) => {
    setTodoListLoading(true);
    const response = await getTodoList(
      current_page,
      page_limit,
      filter,
      queryOptions
    );

    if (response) {
      setPagination({
        currentPage: response.metadata.page,
        pageLimit: response.metadata.limit,
        totalPages: response.metadata.total_pages,
        totalEntries: response.metadata.total_results
      });
      setTodoList(response.data);
      setTodoListLoading(false);
    }
  };

  /**
   *
   * @param {string} searchQuery
   */
  function populateSearchOptions(searchQuery) {
    const parsedQuery = QParse(searchQuery.substring(1));
    if (parsedQuery.startDate) {
      setExpectedDateFilter((pv) => {
        return {
          ...pv,
          startDate: new Date(parsedQuery.startDate)
        };
      });
    }
    if (parsedQuery.endDate) {
      setExpectedDateFilter((pv) => {
        return {
          ...pv,
          endDate: new Date(parsedQuery.endDate)
        };
      });
    }
    if (parsedQuery.status) {
      const selectedStatus = todoStatusOptions.filter(
        (i) => i.value === parsedQuery.status
      );
      setFilterStatus(selectedStatus);
    }
    if (parsedQuery.assignedTo) {
      const staffId = parsedQuery.assignedTo.split(',').map((i) => i.trim());
      setStaffQueryId(staffId);
    }

    //setIsDeleted(parsedQuery.isDeleted);

    fetchData(1, null, activeTab, parsedQuery);
    updateFilterCount(parsedQuery);
  }

  function createQueryOptions(
    startDate = expectedDateFilter.startDate,
    endDate = expectedDateFilter.endDate,
    staff = selectedStaffOption,
    status = filterStatus,
    filterDeleted = isDeleted
  ) {
    setFilterError(false);
    if ((startDate && !endDate) || (!startDate && endDate)) {
      setFilterError('Select valid date range');
      return;
    }
    const startDateISOString = validator.isDate(startDate)
      ? new Date(startDate).toISOString()
      : '';
    const endDateISOString = validator.isDate(endDate)
      ? new Date(endDate).toISOString()
      : '';
    const assignedToStaff = Array.isArray(staff)
      ? staff.map((i) => i.value._id).join(',')
      : '';
    const todoFilterStatus = status ? status.value : '';
    const queryOptions = {
      startDate: startDateISOString,
      endDate: endDateISOString,
      assignedTo: assignedToStaff,
      status: todoFilterStatus,
      isDeleted: filterDeleted
    };
    updateUrlPath(queryOptions);
    updateFilterCount(queryOptions);
    return queryOptions;
  }

  function updateUrlPath(queryOptions) {
    const queryString = QStringify(queryOptions);
    history.replace(`/todos?${queryString}`);
  }

  async function fetchStaffList() {
    const response = await getStaffList(1, 100);
    if (response) {
      setStaffList(response.data);
    }
  }

  function openAddTodoModal() {
    setAddTodoModalOpen(true);
  }

  function closeAddTodoModal() {
    setAddTodoModalOpen(false);
  }

  function openTodoInfoModal(roleId) {
    fetchTodoInfo(roleId);
    setTodoInfoModalOpen(true);
  }

  function closeTodoInfoModal() {
    setTodoInfoModalOpen(false);
  }

  async function openUpdateTodoModal(todoId) {
    fetchTodoInfo(todoId);
    setUpdateTodoModalOpen(true);
  }

  function closeUpdateTodoModal() {
    setUpdateTodoModalOpen(false);
  }

  async function openDeleteTodoModal(todoId, requestType) {
    setTodoId({
      todoId,
      requestType
    });
    setDeleteTodoModalOpen(true);
  }

  function closeDeleteTodoModal() {
    setDeleteTodoModalOpen(false);
  }

  function resetFields() {
    setIsDeleted(false);
    setSelectedStaffOption(null);
    setExpectedDateFilter({
      startDate: null,
      endDate: null
    });
    setFilterStatus(null);
  }

  async function fetchTodoInfo(todoId) {
    setTodoInfoLoading(true);
    const response = await getTodoInfo(todoId);
    if (response) {
      setTodoInfo(response);
      setTodoInfoLoading(false);
    }
  }

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  function openFilterModal() {
    setFilterModalOpen(true);
  }

  function closeFilterModal() {
    setFilterModalOpen(false);
  }

  function updateFilterCount(option) {
    let count = 0;
    Object.keys(option).forEach((i) => {
      if (option[i]?.toString()?.trim()?.length > 0 && option[i] !== false) {
        count += 1;
      }
    });
    setCurrentFilterCount(count);
  }

  /**
   *
   * @param {array<date>} dates
   */
  function dateRangeHandler(dates) {
    const [start, end] = dates;
    setExpectedDateFilter({
      startDate: start,
      endDate: end
    });
  }

  /**
   *
   * @param {array<object>} staffArray
   * @returns
   */
  function buildStaffOptions(staffArray) {
    const staffOptions = staffArray.map((i) => {
      return {
        label: `${i.name} - ${i.role?.role_name}`,
        value: i
      };
    });
    const selectedStaff = staffOptions.filter((i) =>
      staffQueryId.includes(i.value._id)
    );
    setSelectedStaffOption(selectedStaff);
    return staffOptions;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Modal isOpen={filterModalOpen} backdrop="static" size="md">
          <ModalHeader toggle={closeFilterModal}>Filter Task</ModalHeader>
          <AvForm
            className="needs-validation"
            onValidSubmit={async () => {
              let options = await createQueryOptions();
              if (options) {
                await fetchData(1, null, activeTab, options);
                closeFilterModal();
              }
            }}
          >
            <ModalBody>
              {filterError ? (
                <Alert
                  color="danger"
                  role="alert"
                  isOpen={filterError ? true : false}
                  toggle={() => setFilterError(false)}
                >
                  <i className="mdi mdi-block-helper mr-2"></i>
                  {filterError}
                </Alert>
              ) : null}
              <Row>
                <Col md="12">
                  <FormGroup className="mb-0">
                    <Label>Expected Date</Label>
                    <div className="d-flex justify-content-center">
                      <DatePicker
                        selected={expectedDateFilter.startDate}
                        selectsStart
                        className="form-control"
                        startDate={expectedDateFilter.startDate}
                        endDate={expectedDateFilter.endDate}
                        selectsRange={true}
                        dateFormat="dd-MM-yyyy"
                        onChange={dateRangeHandler}
                        isClearable={true}
                      />
                    </div>
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup className="mt-3">
                    <Label>Assigned To</Label>
                    <Select
                      options={staffOptions}
                      onChange={(e) => setSelectedStaffOption(e)}
                      value={selectedStaffOption}
                      components={animatedComponents}
                      styles={selectStyles}
                      isMulti
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <Label>Status</Label>
                    <Select
                      components={animatedComponents}
                      options={todoStatusOptions}
                      onChange={(e) => setFilterStatus(e)}
                      value={filterStatus}
                      isClearable={true}
                      styles={selectStyles}
                    />
                  </FormGroup>
                </Col>

                {authUser && authUser.user_type === 'super_admin' && (
                  <Col md="12">
                    <FormGroup>
                      <Label>Is Deleted</Label>
                      <div
                        className="custom-control custom-switch mb-2"
                        dir="ltr"
                      >
                        <Input
                          id="customSwitch"
                          name="isComplted"
                          type="checkbox"
                          className="custom-control-input p-3"
                          defaultChecked={isDeleted}
                        />
                        <Label
                          htmlFor="customSwitch"
                          className="custom-control-label"
                          onClick={() => setIsDeleted(!isDeleted)}
                        >
                          Deleted Tasks
                        </Label>
                      </div>
                    </FormGroup>
                  </Col>
                )}
              </Row>
              <Row className="d-flex px-3" style={{ height: '100%' }}></Row>
            </ModalBody>
            <ModalFooter>
              <Button size="sm" type="submit" color="primary">
                Apply Filter
              </Button>
              <Button
                size="sm"
                type="button"
                color="success"
                onClick={async () => {
                  await resetFields();
                  let options = await createQueryOptions(
                    null,
                    null,
                    null,
                    null,
                    null
                  );
                  if (options) {
                    await fetchData(1, null, activeTab, options);
                    closeFilterModal();
                  }
                }}
              >
                Reset
              </Button>
              <Button
                size="sm"
                type="button"
                color="light"
                onClick={closeFilterModal}
              >
                Close
              </Button>
            </ModalFooter>
          </AvForm>
        </Modal>
        <CreateTodoModal
          modalOpenState={addTodoModalOpen}
          closeModalHandler={closeAddTodoModal}
          fetchNewTodoList={async () => {
            let options = await createQueryOptions();
            if (options) {
              await fetchData(1, null, activeTab, options);
            }
          }}
          authUser={authUser}
        />
        <ViewTodoModal
          modalOpenState={todoInfoModalOpen}
          closeModalHandler={closeTodoInfoModal}
          todoInfo={todoInfo}
          todoInfoLoading={todoInfoLoading}
        />
        <UpdateTodoModal
          modalOpenState={updateTodoModalOpen}
          closeModalHandler={closeUpdateTodoModal}
          todoInfo={todoInfo}
          todoInfoLoading={todoInfoLoading}
          fetchNewTodoList={async () => {
            let options = await createQueryOptions();
            if (options) {
              await fetchData(1, null, activeTab, options);
            }
          }}
        />
        {todoId && (
          <DeleteTodoModal
            modalOpenState={deleteTodoModalOpen}
            closeModalHandler={closeDeleteTodoModal}
            todoId={todoId.todoId}
            type={todoId.requestType}
            fetchNewData={async () => {
              let options = await createQueryOptions();
              if (options) {
                await fetchData(1, null, activeTab, options);
              }
            }}
          />
        )}
        <Container fluid>
          <Breadcrumbs title="View Tasks" breadcrumbItems={breadcrumbItems} />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <>
                    <Row>
                      <Col className="d-flex justify-content-end align-items-center">
                        <Button
                          size="sm"
                          color="primary"
                          className=" waves-effect waves-light mr-3"
                          onClick={openFilterModal}
                        >
                          <i className="ri-filter-fill align-middle mr-2"></i>
                          <span>Filter Task</span>
                          {currentFilterCount > 0 && (
                            <Badge color="light" pill className="ml-2">
                              {currentFilterCount}
                            </Badge>
                          )}
                        </Button>
                        <Button
                          size="sm"
                          color="success"
                          className=" waves-effect waves-light"
                          onClick={openAddTodoModal}
                        >
                          <i className="ri-add-line align-middle mr-2"></i>
                          Add Task
                        </Button>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col>
                        <Nav tabs className="nav-tabs-custom nav-justified">
                          <NavItem>
                            <NavLink
                              className={
                                activeTab === 'assigned_by' && 'active'
                              }
                              onClick={() => {
                                toggle('assigned_by');
                                fetchData(
                                  1,
                                  null,
                                  'assigned_by',
                                  createQueryOptions()
                                );
                              }}
                            >
                              Created By You
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={
                                activeTab === 'assigned_to' && 'active'
                              }
                              onClick={() => {
                                toggle('assigned_to');
                                fetchData(
                                  1,
                                  null,
                                  'assigned_to',
                                  createQueryOptions()
                                );
                              }}
                            >
                              Assigned To You
                            </NavLink>
                          </NavItem>
                          {authUser && authUser.user_type === 'super_admin' && (
                            <NavItem>
                              <NavLink
                                className={activeTab === 'all' && 'active'}
                                onClick={() => {
                                  toggle('all');
                                  fetchData(
                                    1,
                                    null,
                                    'all',
                                    createQueryOptions()
                                  );
                                }}
                              >
                                All Tasks
                              </NavLink>
                            </NavItem>
                          )}
                        </Nav>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md="2">
                        <FormGroup>
                          <Label>Show Entries</Label>
                          <select
                            className="form-control"
                            onChange={(e) => {
                              fetchData(1, e.target.value);
                              setPagination({
                                ...pagination,
                                pageLimit: e.target.value
                              });
                            }}
                            value={pagination.pageLimit}
                            disabled={todoListLoading}
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                        </FormGroup>
                      </Col>
                    </Row>
                    {todoListLoading ? (
                      <div className="text-center">
                        <PageDataLoader />
                      </div>
                    ) : (
                      <div className="table-rep-plugin">
                        <div
                          className="table-responsive mb-0"
                          data-pattern="priority-columns"
                        >
                          <Table
                            id="tech-companies-1"
                            striped
                            bordered
                            responsive
                          >
                            <thead>
                              <tr>
                                <th>SL. No</th>
                                <th>Title</th>
                                {activeTab !== 'assigned_by' && (
                                  <th>Assigned By</th>
                                )}
                                {activeTab !== 'assigned_to' && (
                                  <th>Assigned To</th>
                                )}
                                <th>Expected Date</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {todoList?.map((item, index) => (
                                <tr key={index}>
                                  <th>{index + 1}</th>
                                  <td>{item.title}</td>
                                  {activeTab !== 'assigned_by' && (
                                    <td>
                                      {item.assigned_by.name +
                                        ' [' +
                                        _.upperCase(item.assigned_by_role) +
                                        ']'}
                                    </td>
                                  )}
                                  {activeTab !== 'assigned_to' && (
                                    <td>
                                      <Link to={`/staff`}>{item.assigned_to.name +
                                        ' [' +
                                        _.upperCase(item.assigned_to_role) +
                                        ']'}</Link>
                                    </td>
                                  )}
                                  <td>
                                    {moment(
                                      new Date(item.expected_date)
                                    ).format('DD-MM-YYYY')}
                                  </td>
                                  <td>
                                    <Badge
                                      className="p-2"
                                      color={
                                        item.status === 'New'
                                          ? 'primary'
                                          : item.status === 'In Progress'
                                          ? 'warning'
                                          : item.status === 'Blocked'
                                          ? 'danger'
                                          : 'success'
                                      }
                                      pill
                                    >
                                      {item.status}
                                    </Badge>
                                  </td>
                                  <td>
                                    <Button
                                      size="sm"
                                      color="primary"
                                      className=" waves-effect waves-light mr-2 mb-2"
                                      onClick={() => {
                                        openTodoInfoModal(item._id);
                                      }}
                                    >
                                      <i className="fas fa-eye mr-2"></i>
                                      View
                                    </Button>

                                    <Button
                                      size="sm"
                                      color="warning"
                                      className=" waves-effect waves-light mr-2 mb-2"
                                      onClick={() => {
                                        openUpdateTodoModal(item._id);
                                      }}
                                    >
                                      <i className="fas fa-edit mr-2"></i>
                                      Edit
                                    </Button>
                                    {activeTab === 'assigned_by' && (
                                      <Button
                                        size="sm"
                                        color="danger"
                                        className=" waves-effect waves-light mb-2"
                                        onClick={() => {
                                          openDeleteTodoModal(
                                            item._id,
                                            item.isDeleted
                                              ? 'restore'
                                              : 'delete'
                                          );
                                        }}
                                      >
                                        {item.isDeleted ? (
                                          <i className="fas fa-trash-restore mr-2"></i>
                                        ) : (
                                          <i className="fas fa-trash mr-2"></i>
                                        )}
                                        {item.isDeleted ? 'Restore' : 'Delete'}
                                      </Button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    )}
                    <Row className="mt-2">
                      <Col md="5">
                        <p>
                          <strong>
                            {' '}
                            Showing{' '}
                            {(pagination.currentPage - 1) *
                              pagination.pageLimit +
                              1}{' '}
                            to{' '}
                            {Math.min(
                              pagination.currentPage * pagination.pageLimit,
                              pagination.totalEntries
                            )}{' '}
                            of {pagination.totalEntries} entries
                          </strong>
                        </p>
                      </Col>
                      {!todoListLoading && todoList.length > 0 && (
                        <Col md="7">
                          <Paginator
                            totalPages={pagination.totalPages}
                            currentPage={pagination.currentPage}
                            changePage={handlePagination}
                          />
                        </Col>
                      )}
                    </Row>
                  </>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(TodoListPage);
